import FirstScreen from '../FirstScreen'
import SecondScreen from '../SecondScreen'
import ThirdScreen from '../ThirdScreen'
import ForthScreen from '../ForthScreen'
import './index.scss'
import FifthScreen from '../FifthScreen'
import React, { useEffect, useState } from 'react'
import Footer from '../../../Footer'
import { observer } from 'mobx-react'
import ContentState from '../../../../stores/ContentState'
import CommerceScreen from '../CommerceScreen/CommerceScreen'
import MarketplaceScreen from '../MarketplaceScreen/MarketplaceScreen'
import WelcomeScreen from '../WelcomeScreen/WelcomeScreen'
const Screen = observer(() => {
  useEffect(() => {
    if (!document.querySelectorAll('.screen')) return

    if (window.IntersectionObserver) {
      let observer = new IntersectionObserver(
        (entries, observer) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              document
                .querySelectorAll('.screen')
                .forEach((s) => s.classList.remove('anim'))
              entry.target.classList.add('anim')
              if (
                entry.target.classList.contains("air") ||
                entry.target.classList.contains("business") ||
                entry.target.classList.contains("friendly") ||
                entry.target.classList.contains("footer") ||
                entry.target.classList.contains("market") ||
                entry.target.classList.contains("commerce") ||
                entry.target.classList.contains("welcome")
              ) {
                document.querySelector(".navigation")?.classList.add("light");
                document.querySelector("header")?.classList.add("light");

                if (
                  !document
                    .querySelector(".navigation")
                    ?.classList.contains("light")
                ) {
                  document.querySelector(".navigation")?.classList.add("light");
                }
              } else {
                document
                  .querySelector(".navigation")
                  ?.classList.remove("light");
                document.querySelector("header")?.classList.remove("light");
              }
            }
          })
        },
        {
          root: null,
          threshold: window.innerWidth > 900 ? 0.8 : [0.4, 0.8, 1],
          rootMargin: '0px',
        },
      )

      document.querySelectorAll('.screen').forEach((s) => {
        observer.observe(s)
      })
    } else {
      const container = document.querySelector('.container')
      if (!container) return
      const offsets: any = []
      const screens = document.querySelectorAll('.screen')
      if (screens) {
        screens.forEach((s) => {
          s.classList.add('anim')
        })
      }
    }
  }, [ContentState.home])

  return (
    <div id="pagescroll">
      <WelcomeScreen />
      <SecondScreen />
      <FirstScreen />
      <CommerceScreen />
      <MarketplaceScreen />
      <ThirdScreen />
      <ForthScreen />
      <FifthScreen />
      <Footer />
    </div>
  )
})

export default Screen
